
import PropTypes from 'prop-types'
import React from 'react'
import { Pane, Body1, Display5, minorScale } from '@segment/react-ui-library'
import css from './WorkspaceNotifications.module.css'
import moment from 'moment'

const WorkspaceNotificationBody = props => {
  // if text is too long, truncate to ellipsis
  const bodyText = props.body.length > 95 ? props.body.substring(0, 95) + '...' : props.body

  const timestamp = moment(props.timestamp).format('MM/DD/YYYY H:mma')

  return (
    <a className={css.Notification} onClick={props.onClick} href={props.url} target='_blank'>
      <div className={css.NotificationBody}>
        <Pane
          paddingLeft={minorScale(3)}
          className={css.Status} />
        <Pane flexDirection='column'>
          <Display5 className={css.TitleText} title={props.title}>{props.title}</Display5>
          <Body1 title={props.body}>{bodyText}</Body1>
          {props.category === 'updates' && <Body1 textColor='muted'>{timestamp}</Body1>}
        </Pane>
      </div>
      <div className={css.Hr} />
    </a>
  )
}

WorkspaceNotificationBody.propTypes = {
  body: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  read: PropTypes.bool.isRequired,
  timestamp: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
}

WorkspaceNotificationBody.displayName = 'WorkspaceNotificationBody'

export default WorkspaceNotificationBody



// WEBPACK FOOTER //
// ./components/WorkspaceNotifications/WorkspaceNotificationsBody.js